import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MenuStateContextProps {
  openMenus: { [key: string]: boolean };
  toggleMenu: (moduleId: string) => void;
}

const MenuStateContext = createContext<MenuStateContextProps | undefined>(undefined);

export const MenuStateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  const toggleMenu = (moduleId: string) => {
    setOpenMenus(prevState => {
      const isOpen = !!prevState[moduleId];

      if (isOpen) {
        return {};
      }

      return { [moduleId]: true };
    });
  };

  return (
    <MenuStateContext.Provider value={{ openMenus, toggleMenu }}>
      {children}
    </MenuStateContext.Provider>
  );
};

export const useMenuState = (): MenuStateContextProps => {
  const context = useContext(MenuStateContext);
  if (!context) {
    throw new Error('useMenuState must be used within a MenuStateProvider');
  }
  return context;
};
